// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @module block
   */
  var block = {

    /**
     * Property to handle flagging when navigation is expanded.
     */
    expanded: false,

    /**
     * Method to handle block initialization.
     */
    init: function() {

      // Get the DOM element reference
      // The dom and doms methods are shorthands for document.querySelector...
      // See /src/scripts/utils/dom.js
      ui.block = dom(".header");

      // If no header on the page, skip
      if (!ui.block) {
        return;
      }

      // Get the navigation toggle reference
      ui.toggle = doms(".header-toggle-button");

      // Handle toggling the expanded navigation open / closed
      // The bind method is shorthand for addEventListener with array support
      // See /src/scripts/utils/dom.js
      bind(ui.toggle, "click", block.toggle);

      // Get the navigation items references
      ui.items = doms(".header-navigation-listitem");

      // Handle expanding the navigation open/closed on mouse over/out
      bind(ui.items, "mouseover", block.open);
      bind(ui.items, "mouseout", block.close);

    },

    /**
     * Method to handle sub navigation opening.
     */
    open: function() {

      // Only handle this on large screens
      if (window.innerWidth < 1024) {
        return;
      }

      // Keep track of the expanded state
      block.expanded = true;

      // Prevent page from scrolling when open
      document.body.style.overflow = "hidden";

      // Change the data attribute to display the sub navigation
      ui.block.dataset.expanded = "true";

    },

    /**
     * Method to handle sub navigation closing.
     */
    close: function() {

      // Only handle this on large screens
      if (window.innerWidth < 1024) {
        return;
      }

      // Keep track of the expanded state
      block.expanded = false;

      // Allow page to scroll after closing
      document.body.style.overflow = "";

      // Change the data attribute to hide the sub navigation
      ui.block.dataset.expanded = "false";

    },

    /**
     * Method to handle sub navigation toggling.
     */
    toggle: function(event) {

      event.preventDefault();

      // Flip the value to update
      block.expanded = !block.expanded;

      // Prevent page from scrolling when open
      document.body.style.overflow = block.expanded ? "hidden" : "";

      // Change the data attribute to display/hide the sub navigation
      ui.block.dataset.expanded = block.expanded ? "true" : "false";

    },

  };

  // Bind the init to the global block init event
  app.events.on("app.blocks.init", block.init.bind(block));

})();
